// extracted by mini-css-extract-plugin
export default {"contenButtons":"BtnAndTable_contenButtons__gpPEq"};